// extracted by mini-css-extract-plugin
export default {"form":"CpMKSuAp6yQ1V6W4Gdjw__form___","footer":"fJ7ms6_xtEiU0I5On8t3__footer___"};